import type { EarlyBirdPricing } from './types'
import { ref } from 'vue'
import { useIntervalFn } from '@vueuse/core'

export function activeEarlyBirdPricing(
  pricing: EarlyBirdPricing | null | undefined,
  elapsedMs: number,
): EarlyBirdPricing | null {
  return pricing && elapsedMs <= Date.parse(pricing.expiresAt) - Date.parse(pricing.clockStartedAt) ? pricing : null
}

export function usePromotionElapsedTime() {
  const navigation = performance.getEntriesByType?.('navigation')[0]
  // Count time spent loading the page too, without trusting the device's wall clock.
  const requestStart =
    navigation && 'requestStart' in navigation && typeof navigation.requestStart === 'number'
      ? navigation.requestStart
      : 0
  const elapsedMs = ref(performance.now() - requestStart)
  useIntervalFn(() => {
    elapsedMs.value = performance.now() - requestStart
  }, 1000)
  return elapsedMs
}
